"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVueComponentTrace = exports.getVueComponentOwner = exports.getVueComponentName = exports.ROOT_COMPONENT_NAME = exports.ANONYMOUS_COMPONENT_NAME = void 0;
exports.ANONYMOUS_COMPONENT_NAME = '<AnonymousComponent>';
exports.ROOT_COMPONENT_NAME = '<Root>';
const getVueComponentName = (vm) => {
    if (!vm) {
        return exports.ANONYMOUS_COMPONENT_NAME;
    }
    if (vm.$root === vm) {
        return exports.ROOT_COMPONENT_NAME;
    }
    if (vm.$options.name) {
        return `<${vm.$options.name}>`;
    }
    const fileName = getVueComponentFileName(vm);
    if (fileName) {
        return `<${getFileBasename(fileName)}>`;
    }
    return exports.ANONYMOUS_COMPONENT_NAME;
};
exports.getVueComponentName = getVueComponentName;
const getFileBasename = (fileName) => {
    const slashIndex = fileName.lastIndexOf('/');
    const filenameWithoutPath = slashIndex >= 0 ? fileName.substr(slashIndex + 1) : fileName;
    return filenameWithoutPath.replace('.vue', '');
};
const getVueComponentOwner = (vm) => {
    var _a;
    if (vm === null) {
        return 'unknown';
    }
    return (_a = vm.$options.owner) !== null && _a !== void 0 ? _a : (0, exports.getVueComponentOwner)(vm.$parent);
};
exports.getVueComponentOwner = getVueComponentOwner;
const getVueComponentTrace = (vm) => {
    const vms = getVueComponentTraceVms(vm);
    return formatVueComponentTrace(vms);
};
exports.getVueComponentTrace = getVueComponentTrace;
const getVueComponentTraceVms = (vm) => {
    if (!vm) {
        return [];
    }
    return [vm, ...getVueComponentTraceVms(vm.$parent)];
};
/**
 * This returns a stringified component tree like this:
 * <FirstComponent> at /path/to/FirstComponent.vue
 *  <SecondComponent> at /path/to/SecondComponent.vue
 *   <ThirdComponent> at /path/to/ThirdComponent.vue
 *    <Root>
 */
const formatVueComponentTrace = (vms) => {
    return vms.map(formatVueComponentElement).map(indent).join('\n');
};
const formatVueComponentElement = (vm) => {
    const name = (0, exports.getVueComponentName)(vm);
    const filename = getVueComponentFileName(vm);
    const location = name === exports.ROOT_COMPONENT_NAME || !filename ? '' : ` at ${filename}`;
    return `${name}${location}`;
};
const getVueComponentFileName = (vm) => {
    // This option may be available if client enables it: https://vue-loader.vuejs.org/options.html#exposefilename
    const { __file } = (vm === null || vm === void 0 ? void 0 : vm.$options) || {};
    return __file !== null && __file !== void 0 ? __file : null;
};
const indent = (element, number) => {
    const whitespaceChar = ' ';
    const indentation = Array(number).fill(whitespaceChar).join('');
    return `${indentation}${element}`;
};
//# sourceMappingURL=utils.js.map